export const lotStatus = {
  WAIT: 'WAIT',
  NEW: 'NEW',
  ACTIVE: 'ACTIVE',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  CANCELED: 'CANCELED',
}
